import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/profile',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/ProfileView.vue')
  },
  {
    path: '/governance',
    name: 'governance',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/GoverView.vue')
  },
  {
    path: '/laporan',
    name: 'laporan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/ReporView.vue')
  },
  {
    path: '/berita',
    name: 'berita',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/NewsView.vue')
  },
  {
    path: '/pengadaan',
    name: 'pengadaan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/ProcuView.vue')
  },
  {
    path: '/pabrik',
    name: 'pabrik',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/FactoView.vue')
  },
  {
    path: '/media',
    name: 'media',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/MediaView.vue')
  },
  {
    path: '/Keberlanjutan',
    name: 'keberlanjutan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/KeberView.vue')
  },
  {
    path: '/galeri',
    name: 'galeri',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/GalerView.vue')
  },
  {
    path: '/sketch',
    name: 'sketch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/SketcView.vue')
  },
  {
    path: '/buzz',
    name: 'buzz',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/BUZZView.vue')
  },
  {
    path: '/complaint',
    name: 'complaint',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/TataKelola/Complaint.vue')
  },
  {
    path: '/governance',
    name: 'governance',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/TataKelola/Governance.vue')
  },
  {
    path: '/wbs',
    name: 'wbs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/TataKelola/WBS.vue')
  },
  {
    path: '/audit',
    name: 'audit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/TataKelola/AuditCharterPlaque.vue')
  },
  {
    path: '/procurement',
    name: 'procurement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/TataKelola/Procurement.vue')
  },
  {
    path: '/ggcp',
    name: 'ggcp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Lingkungan/Pabrik/GGCP.vue')
  },
  {
    path: '/kdm',
    name: 'kdm',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Lingkungan/AnakPerusahaan/KDM.vue')
  },
  {
    path: '/penghargaan',
    name: 'penghargaan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Profile/Award.vue')
  },
  {
    path: '/manajemen',
    name: 'manajemen',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Profile/Management.vue')
  },
  {
    path: '/struktur',
    name: 'struktur',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Profile/Structure.vue')
  },
  {
    path: '/nilai',
    name: 'nilai',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Profile/Value.vue')
  },
  {
    path: '/visimisi',
    name: 'visimisi',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Profile/VisionMission.vue')
  },
  {
    path: '/sejarah',
    name: 'sejarah',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Profile/History.vue')
  },
  {
    path: '/artikel',
    name: 'artikel',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/Article.vue')
  },
  {
    path: '/pers',
    name: 'pers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/Pers.vue')
  },
  {
    path: '/layanan/investasi-energiutilitas-strategis',
    name: 'investasi-energiutilitas-strategis',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/HalamanTeks.vue')
  },
  {
    path: '/layanan/operasi-pemeliharaan',
    name: 'operasi-pemeliharaan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/OperasidanPemeliharaan.vue')
  },
  {
    path: '/layanan/perdagangan-eenrgi-primergas-industri',
    name: 'perdagangan-eenrgi-primergas-industri',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/PerdaganganEnrgiPrimerGasIndustri.vue')
  },
  {
    path: '/layanan/kemitraan-prengembangan-proyek',
    name: 'kemitraan-pengembangan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/kemitraanprengembanganproyek.vue')
  },
  {
    path: '/layanan/portofolio-energi-terbarukan',
    name: 'portofolio-energi-terbarukan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Berita/portofolioenergi.vue')
  },
  {
    path: '/pers/2016',
    name: '2016',
    component: () => import('../views/Pers/2016.vue')
  },
  {
    path: '/pers/2019',
    name: '2019',
    component: () => import('../views/Pers/2019.vue')
  },
  {
    path: '/pers/2020',
    name: '2020',
    component: () => import('../views/Pers/2020.vue')
  },
  {
    path: '/pers/2021',
    name: '2021',
    component: () => import('../views/Pers/2021.vue')
  },
  {
    path: '/pers/2022',
    name: '2022',
    component: () => import('../views/Pers/2022.vue')
  },
  {
    path: '/pers/2023',
    name: '2023',
    component: () => import('../views/Pers/2023.vue')
  },
  {
    path: '/pers/2024',
    name: '2024',
    component: () => import('../views/Pers/2024.vue')
  },
  {
    path: '/pers/2025',
    name: '2025',
    component: () => import('../views/Pers/2025.vue')
  },
  {
    path: '/artikel/2019',
    name: 'Artikel 2019',
    component: () => import('../views/Artikel/2019.vue')
  },
  {
    path: '/artikel/2020',
    name: 'Artikel 2020',
    component: () => import('../views/Artikel/2020.vue')
  },
  {
    path: '/artikel/2021',
    name: 'Artikel 2021',
    component: () => import('../views/Artikel/2021.vue')
  },
  {
    path: '/artikel/2022',
    name: 'Artikel 2022',
    component: () => import('../views/Artikel/2022.vue')
  },
  {
    path: '/artikel/2023',
    name: 'Artikel 2023',
    component: () => import('../views/Artikel/2023.vue')
  },
  {
    path: '/artikel/2024',
    name: 'Artikel 2024',
    component: () => import('../views/Artikel/2024.vue')
  },
  {
    path: '/artikel/2025',
    name: 'Artikel 2025',
    component: () => import('../views/Artikel/2025.vue')
  },
  {
    path: '/lapkeu',
    name: 'lapkeu',
    component: () => import ('../views/Laporan/Financial.vue')
  },
  {
    path: '/laptah',
    name: 'laptah',
    component: () => import ('../views/Laporan/Yearly.vue')
  },
  {
    path: '/lapkeb',
    name: 'lapkeb',
    component: () => import ('../views/Laporan/Sustainability.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import ('../views/ContactView.vue')
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
